import { CIActionBtnGroup, Input } from 'ccs-ui-components';
import { useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { PASSWORD_ICON } from '../../../../../../constants';
import { IServiceDetailsValidationModel } from '../../../../../../models';

import classes from './UsernamePassword.module.scss';
import { ServiceVariableTooltipUsername } from '../../../../../../utilities/services/ServiceVariableTooltipUsername';
import { ServiceVariableTooltipPwd } from '../../../../../../utilities/services/ServiceVariableTooltipPwd';

interface IUserNamePasswordProps {
  formData: IServiceDetailsValidationModel;
  handleInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  isEdit: boolean;
}
const UserNamePassword = ({
  formData,
  handleInputChange,
  isEdit
}: IUserNamePasswordProps) => {
  const { t: translate } = useTranslation();
  const [passwordIconName, setPasswordIconName] = useState(PASSWORD_ICON.HIDE_PASSWORD);

  /**
   * @method showHidePassword
   * @description displays the show/hide password icon
   */
  const showHidePassword = () => {
    setPasswordIconName(passwordIconName === PASSWORD_ICON.HIDE_PASSWORD ? PASSWORD_ICON.SHOW_PASSWORD : PASSWORD_ICON.HIDE_PASSWORD);
  };

  return (
    <Row>
      <Col md={6}>
        <Form.Group className="mb-3" controlId="username">
          <Input
            isMandatory
            labelText={String(translate('service_details_form_component.lbl_username'))}
            infoIconTxt={<ServiceVariableTooltipUsername />}
            label=""
            name="userName"
            placeholder={String(translate('service_details_form_component.plchd_username'))}
            onChange={handleInputChange}
            value={formData.userName.value}
            error={!formData.userName.isValid && isEdit}
            data-testid="username"
            errorTxt={isEdit ? formData.userName.error : ''}
            maxLength={Number.MAX_SAFE_INTEGER}
          />
        </Form.Group>
      </Col>
      <Col md={6}>
        <div className={classes['password-container']}>
          <Form.Group
            controlId="password"
            className={classes['password-input']}
          >
            <Input
              isMandatory
              labelText={String(translate('service_details_form_component.lbl_password'))}
              infoIconTxt={<ServiceVariableTooltipPwd />}
              label=""
              placeholder={String(translate('service_details_form_component.plchd_password'))}
              name="password"
              onChange={handleInputChange}
              value={formData.password.value}
              error={!formData.password.isValid && isEdit}
              errorTxt={isEdit ? formData.password.error : ''}
              data-testid="password"
              maxLength={Number.MAX_SAFE_INTEGER}
            />
          </Form.Group>
        </div>
      </Col>
    </Row>
  );
};

export default UserNamePassword;
